import { zeusApi } from 'src/store/api';
import { type HoldingAlert } from 'src/shared/types/alert';

const extendedApi = zeusApi.injectEndpoints({
  endpoints: build => ({
    getHoldingAlerts: build.query<HoldingAlert[], void>({
      query: () => ({
        url: '/holding/alerts',
        method: 'GET'
      }),
      providesTags: ['HoldingAlerts']
    })
  }),
  overrideExisting: false
});

export const { useGetHoldingAlertsQuery, util: alertUtils } = extendedApi;
